export default __webpack_public_path__ + "static/media/Rectangle 4.24ee985a.png";